<template>
  <div class="my-4">
    <h2>{{ $t('warehouses.table.title') }} {{ amount | brackets }}</h2>
    <v-data-table
      :items="items"
      :headers="headers"
      hide-actions
      :loading="isLoading"
      :headers-length="5"
    >
      <template slot="headers">
        <tr>
          <template v-if="!desktopOnly">
            <th
              v-for="header in headers"
              :key="header.text"
              class="text-xs-left"
            >
              {{ header.text }}
              <BaseIcon
                v-if="header.icon"
                width="16px"
                height="13px"
              >
                <component :is="header.icon" />
              </BaseIcon>
            </th>
          </template>
          <template v-for="header in headers">
            <th
              v-if="!header.desktopOnly && desktopOnly"
              :key="header.text"
              class="text-xs-left"
            >
              {{ header.text }}
              <BaseIcon
                v-if="header.icon"
                width="16px"
                height="13px"
              >
                <component :is="header.icon" />
              </BaseIcon>
            </th>
          </template>
        </tr>
      </template>
      <template
        slot="items"
        slot-scope="props"
      >
        <tr
          @click="showCard(props.item, $event)"
          @contextmenu.prevent="openContext(props.item.warehouse_id, $event)"
        >
          <td>
            {{ props.item.warehouse_id }}
          </td>
          <td>
            {{ props.item.warehouse_name }}
          </td>
          <td v-if="!desktopOnly">
            {{ fullAddress(props.item) }}
          </td>
          <td v-if="!desktopOnly">
            {{ props.item.warehouse_manager.full_name }}
          </td>
          <td>
            <FamilyStatus
              :status="props.item.status"
              :mobile="$vuetify.breakpoint.smAndDown"
            />
          </td>
          <td>
            <ActionMenu
              :items="actionMenuItems"
              :warehouse-id="props.item.warehouse_id"
              @clicked-item="doAction($event, props.item)"
            />
          </td>
        </tr>
      </template>
      <template slot="no-data">
        <tr>
          <td colspan="6">
            <p
              v-show="!isLoading"
              class="text-xs-center pt-3"
            >
              {{ $t('message.error_warehouses_list_empty') }}
            </p>
          </td>
        </tr>
      </template>
    </v-data-table>
    <CustomContextMenu
      :visible="contextData.visible"
      :event="contextData.event"
      :link-name="contextData.linkName"
      :id-param="contextData.id"
      @show="toggleContextMenu()"
    />
  </div>
</template>

<script>
import FamilyStatus from '@/components/widgets/dataTable/FamilyStatus';
import ActionMenu from '@/components/widgets/dataTable/ActionMenu';
import filters from '@/constants/filters';
import CustomContextMenu from '@/components/widgets/CustomContextMenu';

export default {
    name: 'WarehousesTable',
    components: { FamilyStatus, ActionMenu, CustomContextMenu },
    filters: {
        ...filters
    },
    props: {
        items: {
            required: true,
            type: Array
        },
        amount: {
            required: true,
            type: Number
        },
        isLoading: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            headers: [
                {
                    text: this.$t('warehouses.table.headers.0'),
                    desktopOnly: false
                },
                {
                    text: this.$t('warehouses.table.headers.1'),
                    desktopOnly: false
                },
                {
                    text: this.$t('warehouses.table.headers.2'),
                    desktopOnly: true
                },
                {
                    text: this.$t('warehouses.table.headers.3'),
                    desktopOnly: true
                },
                {
                    text: this.$t('warehouses.table.headers.4'),
                    desktopOnly: false
                },
                {
                    text: this.$t('warehouses.table.headers.5'),
                    desktopOnly: false
                }
            ],
            actionMenuItems: [
                {
                    id: 1,
                    text: this.$t('warehouses.table.action'),
                    url: true
                }
            ],
            contextData: {
                visible: false,
                event: null,
                linkName: 'warehouse-card',
                id: null
            }
        };
    },
    computed: {
        desktopOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        }
    },
    methods: {
        fullAddress (item) {
            const _street = item.street ? item.street : '';
            const _building = item.building_number;
            const _flat = item.flat_number === null ? '' : `/${item.flat_number}`;
            const _code = this.$options.filters.postalCode(item.postal_code);
            const _city = item.city;
            return _street + ' ' + _building + _flat + ' ' + _code + ' ' + _city;
        },
        doAction (event, item) {
            this.goToCard(item);
        },
        goToCard (item) {
            this.$router.push({ name: 'warehouse-card', params: { id: item.warehouse_id } });
        },
        showCard (item, event) {
            if (
                event.target.localName === 'td' ||
        event.target.localName === 'p' ||
        event.target.localName === 'span'
            ) {
                this.goToCard(item);
            }
        },
        toggleContextMenu (val) {
            this.contextData.visible = val;
        },
        openContext (id, $event) {
            this.contextData.id = id;
            if (
                $event.target.localName === 'td' ||
        $event.target.localName === 'p' ||
        $event.target.localName === 'span'
            ) {
                this.contextData.visible = true;
                this.contextData.event = $event;
            }
        }
    }
};
</script>

<style scoped></style>
